import Table from '@mui/joy/Table';
import Sheet from '@mui/joy/Sheet';
import { useTheme } from '@mui/joy';

function createData(
	chamber: string,
	party: string,
	gender: string,
	donation: string
) {
	return { chamber, party, gender, donation };
}

const rows = [
	createData('US House', 'Democratic', 'Men', '$116'),
	createData('US House', 'Democratic', 'Women', '$92'),
	createData('US House', 'Republican', 'Men', '$82'),
	createData('US House', 'Republican', 'Women', '$57'),
	createData('US Senate', 'Democratic', 'Men', '$60'),
	createData('US Senate', 'Democratic', 'Women', '$75'),
	createData('US Senate', 'Republican', 'Men', '$109'),
	createData('US Senate', 'Republican', 'Women', '$63')
];

export default function TableSheet() {
	const theme = useTheme();
	return (
		<Sheet
			variant='soft'
			sx={{
				pt: 1,
				borderRadius: 'sm',
				overflowX: 'auto' // allows horizontal scrolling on small screens
			}}
		>
			<Table
				hoverRow
				sx={{
					'--Table-headerUnderlineThickness': '1.5px', //-- border bottom below undoes this
					'--TableCell-borderColor': `${theme.palette.chartElementsBackground.yAxisLabels}`,
					'--TableCell-paddingY': '.25rem',
					marginBottom: '.75rem',
					fontFamily: 'Source Sans Pro',
					fontSize: '1.25rem',
					captionSide: 'top',
					tableLayout: { xs: 'auto', smallLaptop: 'fixed' },
					color: `${theme.palette.chartElementsBackground.subTitle}`,
					'& thead th': {
						color: `${theme.palette.chartElementsBackground.title}`,
						fontWeight: 400
					},
					'& thead th:nth-of-type(even)': {
						bgcolor: `${theme.palette.chartElementsBackground.bg}`
					},
					'& thead th:last-child': { width: '15%' },
					'& tbody': {
						bgcolor: `${theme.palette.chartElementsBackground.bg}`
					},
					'& tr': {
						whiteSpace: 'nowrap'
					},
					'& tr:not(:last-of-type)>td': {
						borderBottomWidth: '.5px'
					},

					'& tr > *:last-child': { textAlign: 'right' }
				}}
			>
				<thead>
					<tr>
						<th>Chamber</th>
						<th>Party</th>
						<th>Candidate Gender</th>
						<th>Donation</th>
					</tr>
				</thead>
				<tbody>
					{rows.map((row) => (
						<tr key={row.donation}>
							<td>{row.chamber}</td>
							<td>{row.party}</td>
							<td>{row.gender}</td>
							<td>{row.donation}</td>
						</tr>
					))}
				</tbody>
			</Table>
		</Sheet>
	);
}
